import {createRouter, createWebHashHistory, createWebHistory, RouteRecordRaw} from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/logIn',
    name: 'logIn',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '@/components/login/logIn.vue'),
    props: true,
    meta: { title: '中药处方溯源' }
  },
  {
    path: '/pSelectResult',
    name: 'pSelectResult',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '@/components/pSelectResult/pSelectResult.vue'),
    props: true,
    meta: { title: '处方查询结果' }
  },
  {
    path: '/prescriptionInfo',
    name: 'prescriptionInfo',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ '@/components/prescriptionInfo/prescriptionInfo.vue'),
    props: true,
    meta: { title: '中药处方溯源' }
  },
  {
    path: '/prescriptionStatus',
    name: 'prescriptionStatus',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '@/components/prescriptionStatus/prescriptionStatus.vue'),
    props: true,
    meta: { title: '处方进度' }
  },
  {
    path: '/deliveryStatus',
    name: 'deliveryStatus',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '@/components/deliveryStatus/deliveryStatus.vue'),
    props: true,
    meta: { title: '配送进度' }
  },
  {
    path: '/evaluatePage',
    name: 'evaluatePage',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '@/components/evaluatePage/evaluatePage.vue'),
    props: true,
    meta: { title: '处方评价' }
  },
  {
    path: '/complaintFeedback',
    name: 'complaintFeedback',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '@/components/complaintFeedback/complaintFeedback.vue'),
    props: true,
    meta: { title: '处方投诉' }
  },
  {
    path: '/deliveryProgress',
    name: 'deliveryProgress',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '@/components/deliveryProgress/deliveryProgress.vue'),
    props: true,
    meta: { title: '配送进度' }
  },
  {
    path: '/mapTemplate',
    name: 'mapTemplate',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '@/components/mapTemplate/mapTemplate.vue'),
    props: true,
    meta: { title: '配送地图' }
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
